import { Route } from '@angular/router';
import { DashboardComponent } from 'src/app/pages/dashboard/dashboard.component';
import { RoutingID } from '../sb-routing-enum';
import { SbIcons } from '@ngx-seatback/icons';

export const home: Route = {
  path: 'home',
  component: DashboardComponent,
  title: 'nav.dashboard',
  data: {
    icon: SbIcons.dashboard,
    breadcrumb: 'nav.dashboard',
    id: RoutingID.home,
  },
};
